
const isNull = (variable) => {
    return ((variable === null) || (typeof variable === "undefined"));
}

const performAppSubmission = async (values) => {
    return new Promise(async (resolve, reject) => {
        try {
            // add an application and outlet
            values.authToken = await generateToken(values);

            let appResp = await addApplication(values);
            values.appResult = appResp.result;

            if (appResp.result !== "SUCCESS") { throw new Error(JSON.stringify(appResp)); }

            values.appRef = appResp.merchant.application_reference;
            values.appInternalMID = appResp.merchant_sub_groups[0].internal_mid;

            let outResp = await addOutlet(values);

            // send an email
            await sendEmail(values);

            resolve("Operations completed successfully!");
        } catch (err) {
            console.error("Error during async operations: ", err);
            reject(err);
        }
    });
};

const generateToken = async (values) => {
    try {
        const genToken = await fetch(
            "/.netlify/functions/generateAuth",
            {
                method: 'POST',
                body: JSON.stringify(values),
            }
        )
        const genTokenText = await (genToken.text())
        return genTokenText
    }
    catch (error) {
        console.error(error);
    }
}

const addApplication = async (values) => {
    try {
        const addApp = await fetch(
            "/.netlify/functions/addApplication",
            {
                method: 'POST',
                body: JSON.stringify(values),
            }
        )
        const appResp = await (addApp.text())
        const parsedResp = JSON.parse(appResp)
        return parsedResp
    }
    catch (error) {
        console.error(error);
    }
}

const addOutlet = async (values) => {
    try {
        const addOutResp = await fetch(
            "/.netlify/functions/addOutlet",
            {
                method: 'POST',
                body: JSON.stringify(values),
            }
        )
    }
    catch (error) {
        console.error(error);
    }
}

const sendEmail = async (values) => {
    try {
        const emailResp = await fetch(
            "/.netlify/functions/emailData",
            {
                method: 'POST',
                body: JSON.stringify(values),
            }
        )
    }
    catch (error) {
        console.error(error);
    }
}

export {
    performAppSubmission
}